import { Input, OnDestroy, Directive, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DeactivateNavigationGuard } from '@cigna/shared/angular/utils-ui';
import { ModalComponent } from '../modal/modal.component';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import { Location } from '@angular/common';

@Directive({
  selector: '[cignaPreventNavigation]',
})
export class PreventNavigationDirective implements OnDestroy {
  private continueNavigation = new Subject<boolean>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  startListening = false;
  continuationLink?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() enabled? = false;

  constructor(
    private el: ModalComponent,
    private guard: DeactivateNavigationGuard,
    private window: WindowService,
    private _router: Router,
    private location: Location,
  ) {
    guard.register(this);

    setTimeout(() => (this.startListening = true));
  }

  canDeactivate() {
    if (!this.enabled) {
      return true;
    }
    this.el.open();

    return this.continueNavigation;
  }

  ngOnDestroy() {
    this.guard.unregister(this);
  }

  @HostListener('document:click', ['$event'])
  handleClick(ev: MouseEvent) {
    if (this.enabled !== true || !this.startListening || this.el.isOpened) {
      return;
    }
    const linkElement = this.findClosestPreventableLink(
      ev.target as HTMLElement,
    );
    if (!linkElement) {
      return;
    }

    this.continuationLink = linkElement.href;
    ev.preventDefault();
    this.el.open();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHander() {
    return !this.enabled || this.continuationLink != null;
  }

  close(cancel: boolean): void {
    this.el.close();
    if (
      this.continuationLink &&
      cancel &&
      this._router.getCurrentNavigation()?.trigger !== 'popstate'
    ) {
      this.window.location.href = this.continuationLink;

      delete this.continuationLink;

      return;
    }
    if (this._router.getCurrentNavigation()?.trigger === 'popstate') {
      this.location.go(this._router.routerState.snapshot.url);
    }

    if (this.continuationLink) {
      delete this.continuationLink;
    }
    this.continueNavigation.next(cancel);
  }

  private isPreventable(target: HTMLElement): boolean {
    return (
      target.getAttribute('href') != null &&
      target.getAttribute('href') !== '' &&
      target.getAttribute('target') !== '_blank'
    );
  }
  private findClosestPreventableLink(
    element: HTMLElement | null,
  ): HTMLLinkElement | undefined {
    let curr = element;
    while (curr != null) {
      if (isLink(curr)) {
        if (this.isPreventable(curr)) {
          return curr;
        }

        return;
      }

      curr = curr.parentElement;
    }
  }
}

function isLink(target: EventTarget | null): target is HTMLLinkElement {
  return target != null && (target as HTMLElement).tagName === 'A';
}
